
angular.module('app.services.squizsearch', ['ngLodash']).factory('SquizSearchService', function($http, $log, lodash) {

  'use strict';
  
  var stateAbbreviationMap = { 'az': 'Arizona', 'nv': 'Nevada', 'ca': 'California','companywide':'Companywide' };
  

  
  var capitalizeFirstLetter = function(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };
  
  
  var _getSquizURL = function() {
    if ((window.location.hostname).indexOf("dev")!==-1) {
      return '//dxp-us-search.funnelback.squiz.cloud/s/search.json';
    } else if((window.location.hostname).indexOf("test")!==-1) {
      return '//dxp-us-search.funnelback.squiz.cloud/s/search.json';
    } else if ((window.location.hostname).indexOf("uat")!==-1) {
      return '//swgas-search.funnelback.squiz.cloud/s/search.json';
    } else {
      return '//swgas-search.funnelback.squiz.cloud/s/search.json';
    }
  };

  var _getSquizSuggestionURL = function() {
    if ((window.location.hostname).indexOf("dev")!==-1) {
      return '//dxp-us-search.funnelback.squiz.cloud/s/suggest.json';
    } else if ((window.location.hostname).indexOf("test")!==-1) {
      return '//dxp-us-search.funnelback.squiz.cloud/s/suggest.json';
    } else if ((window.location.hostname).indexOf("uat")!==-1) {
      return '//swgas-search.funnelback.squiz.cloud/s/suggest.json';
    } else {
      return '//swgas-search.funnelback.squiz.cloud/s/suggest.json';
    }
  };

  var _doSearch = function(options, data) {
    var params = {};
    data = data || {};

    data.loading = true;

    var append = options.append || false;
    if (options.append) {
      delete options.append;
    }

    lodash.defaults(options, { 'start_rank': 0, 'max': 10, 'collection': 'swgas~sp-meta' });
    lodash.defaults(data, { 'results1': [],'results2': [], 'results3': {}, 'hasMore': false });
	
    if(options.facetQueries) {
	  	//console.log("Facet Queries:"+options.facetQueries);
		
		var fQueries = options.facetQueries + '';
		var facetList = fQueries.split('&');
		
    	facetList.forEach(function(queryParam) {			
			//console.log("Parameter: "+queryParam);	  	
			
			var keyfacet = queryParam.substring(queryParam.indexOf(":")+1,queryParam.indexOf("="));
			keyfacet = keyfacet.replace(/\+/g, '%20'); 
			keyfacet = decodeURIComponent(keyfacet);
			var valuefacet = queryParam.substring(queryParam.indexOf("=")+1,queryParam.length);			
			//console.log("Facet Key: "+keyfacet);
			//console.log("Facet Value: "+valuefacet);
			params[keyfacet]=valuefacet;		
    	});
    }
	
    lodash.assign(params, options);
    delete params.facetQueries;
	
	var transform = function(params){
        var str1 = [];
        for(var p in params){
			if(((p==='query')||(p.indexOf('pageCategory')!=-1))&&(params[p].indexOf('\+')!=-1)) {
				str1.push(encodeURIComponent(p) + "=" + decodeURIComponent(params[p]));
			}else{
				str1.push(encodeURIComponent(p) + "=" + encodeURIComponent(params[p]));
				}
	}
        return str1.join("&");
    };
	
    return $http.get(_getSquizURL()+"?"+transform(params)).then(
        function(resp) {
          var results1 = resp.data.response.resultPacket.results;
          var results2 = resp.data.response.facets;
          var results3 = resp.data.response.resultPacket.spell;
          var results4 = resp.data.response.resultPacket.resultsSummary;
          var results5 = resp.data.response.curator.exhibits;
          var results5_es = [];
          var results5_en = [];
		  // Eh, why twice? 
          var results6 = resp.data.response.resultPacket.spell;

          if(params["f.Language|2"]!==undefined && params["f.Language|1"]===undefined){
                                    

                results5.forEach(function(result5,index5) {
                  var results5Item = decodeURIComponent(result5.linkUrl);
                    if(results5Item.indexOf("/es/")!=-1){
                         results5_es.push(result5);
                    }
              });
              
              if(results5_es.length<1){
                results5 = results5_es;
              }
          }
          
           if(params["f.Language|1"]!==undefined && params["f.Language|2"]===undefined){
                  

                results5.forEach(function(result5,index5) {
                  var results5Item = decodeURIComponent(result5.linkUrl);
                    if(results5Item.indexOf("/es/")==-1){
                         results5_en.push(result5);
                       
    
                    }
              });
            }
   
        var selectedFacets = resp.data.question.selectedFacets;
          //var query1 =options.query.toLowerCase();
          var query1 = options.query;
          query1 = query1.replace(/(\s+)/,"(<[^>]+>)*$1(<[^>]+>)*");
          var pattern = new RegExp("("+query1+")", "gi");

          //var pattern = new RegExp(options.query, 'gi');
          var pageSize = 10;
            // calculate total pages
            var totalPages = Math.ceil(results4.totalMatching / pageSize);
            var startPage, endPage,currentPage;
            
            if(params.page===undefined)params.page=1;
            currentPage = params.page;
            //currentPage = results4.currStart;
            if (totalPages <= 5) { 
                // less than 10 total pages so show all
                startPage = 1;
                endPage = totalPages;
            } else {  
                // more than 10 total pages so calculate start and end pages
                if (currentPage <= 3) {
                    startPage = 1;
                    endPage = 5;
                } else if (currentPage + 2 >= totalPages) {
                    startPage = totalPages - 4;
                    endPage = totalPages;
                } else {
                    startPage = currentPage - 2;
                    endPage = currentPage + 2;
                }
            }
            

          var pages = _.range(startPage, endPage + 1);
          
          var pager = {};
          pager.currentPage = currentPage;
          pager.totalPages = totalPages;
          pager.pages = pages;
          
          
          selectedFacets.forEach(function(facetName) {
        	  results2.forEach(function(facet) {
            	  if(facet.name === facetName) {
            		  facet.isSelected = true;
            	  }
              }); 
          });
          
        data.results1 = append ? lodash.union(data.results1, results1) : results1;
		data.results2 = results2;
		data.results3 = results3;
		data.results4 = results4;
		
        if(results5_es.length>0){ 
          data.results5 = results5_es;
        }else if(results5_en.length>0) { 
          data.results5 = results5_en; 
        }else {
           data.results5 = results5;
           }
        data.results6 = results6;

        data.pager = pager;
    	data.results1.forEach(function(result) { 
			if(result.collection === 'swgas-youtube') {
				var videoID = result.liveUrl.substring(result.liveUrl.indexOf('v=')+2, result.liveUrl.indexOf('&'));
				result.embedUrl = 'https://www.youtube.com/embed/'+videoID;
			}
			result.summary = result.summary.replace(pattern, '<span class="light-yellow-bg">$1</span>');
			result.title = result.title.replace(pattern, '<span class="light-yellow-bg">$1</span>');
			
			/*
			if(result.listMetadata.c[0]) 
			{ 
				//alert("Before Desc :"+result.listMetadata.c);
				if(result.listMetadata.c[0].indexOf('|')!==0)
					{ result.listMetadata.c[0] = result.listMetadata.c[0].substring((result.listMetadata.c[0].indexOf('|')+1),result.listMetadata.c[0].length); }
				result.listMetadata.c[0] = result.listMetadata.c[0].replace(pattern, '<span class="light-yellow-bg">$1</span>');
				//alert("After Description :"+result.listMetadata.c);
            }*/
			/*
			if(result.listMetadata.t)
			{
				//alert("Before Title :"+result.listMetadata.t);
				if(result.listMetadata.t.indexOf('|')!==0)
					{ result.listMetadata.t = result.listMetadata.t.substring((result.listMetadata.t.indexOf('|')+1),result.listMetadata.t.length); }
				result.listMetadata.t = result.listMetadata.t.replace(pattern, '<span class="light-yellow-bg">$1</span>');
				//alert("After Title :"+result.listMetadata.t);
			}*/

          /*
          if(result.summary.toLowerCase().indexOf(query1)!=-1) {

             var matchingQuerySummary = result.summary.substring(result.summary.toLowerCase().indexOf(query1),result.summary.toLowerCase().indexOf(query1)+query1.length); 
              
             result.summary = result.summary.replace(pattern, '<mark  class="yellow-bg">'+matchingQuerySummary+'</mark>');
    		  }
          if(result.title.toLowerCase().indexOf(query1)!=-1) {
             var matchingQueryTitle = result.title.substring(result.title.toLowerCase().indexOf(query1),result.title.toLowerCase().indexOf(query1)+query1.length);          
             result.title = result.title.replace(pattern, '<mark  class="yellow-bg">'+matchingQueryTitle+'</mark>');
    		  }*/
    	  });
    	  
			data.results2.forEach(function(facet) {
				facet.allValues.forEach(function(allValue) { 
					if(facet.name === 'State'){
					 allValue.label = stateAbbreviationMap[allValue.label];
					} else if(facet.name === 'Misc Categories') {
						allValue.label = capitalizeFirstLetter(allValue.label);
					} else if(allValue.label === 'HTML') {
						allValue.label = 'Page';
    				}
					//console.log("allValue label :"+allValue.label);
    			 }); 
			});
		  
		  /*
    	  data.results2.forEach(function(facet) {
    		  facet.categories.forEach(function(category) {
    			 category.values.forEach(function(value) { 
    				 if(facet.name === 'State'){
    					 value.label = stateAbbreviationMap[value.label];
						 console.log("value label :"+value.label);
    				 } else if(facet.name === 'Misc Categories') {
               value.label = capitalizeFirstLetter(value.label);
             } else if(value.label === 'HTML') {
    					 value.label = 'Page';
    				 }
    			 }); 
    		  });
    	  });
          */
		  
          data.found = resp.data.response.resultPacket.resultsSummary.totalMatching;
          data.hasMore = (options.start_rank + options.max) < data.found;
        },
        function(resp) {
          $log.error("Error in search: " + JSON.stringify(resp.data.results));
        }
      )
      .finally(function(){
        data.loading = false;
      });
  };

  return {
	findSuggestions: function(options, data) {
		var params = {};
		lodash.defaults(data, { 'loading': true });
		lodash.defaults(options, { 'sort': 0, 'show': 3, 'fmt': 'json++' });
		
		lodash.assign(params, options);
		
		var collectionName = options.collection;
		
		
		var transform = function(params){
        var str1 = [];
        for(var p in params){
			if(((p==='query')||(p.indexOf('pageCategory')!=-1))&&(params[p].indexOf('\+')!=-1)) {
				str1.push(encodeURIComponent(p) + "=" + decodeURIComponent(params[p]));
			}else{
				str1.push(encodeURIComponent(p) + "=" + encodeURIComponent(params[p]));
				}
		}
			return str1.join("&");
		};
		
		
		return $http.get(_getSquizSuggestionURL()+"?"+transform(params)).then(
	        function(resp) {
	        	data[collectionName] = resp.data;
	        	data[collectionName].forEach(function(suggestion) {
	        		if(!suggestion.action) {
	        			suggestion.action = '/en/qsearch?d=Touch&query='+suggestion.disp;
	        		}
	        	});
	        },
	        function(resp) {
	          $log.error("Error in search suggestions: " + JSON.stringify(resp.data));
	        }
	      )
	      .finally(function(){
	    	  data.loading = false;
	      });
	},
	  
    findPages: function(options, data) {
      //options.index = options.index || 'Global';
      return _doSearch(options, data);
    }

  };

});
